import React, { Fragment, useState } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TextField from "@mui/material/TextField";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { AssetTypes, AssetUnitsMaster } from "../../../types/project";
import IconButton from "@mui/material/IconButton/IconButton";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import DeleteSharpIcon from "@mui/icons-material/DeleteSharp";
import AddIcon from "@mui/icons-material/Add";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";

interface UnitsTableProps {
  rows: AssetUnitsMaster[];
  onDelete: (AssetGroupID: string, AssetTypeID: string) => void;
  handleEditClick: (AssetGroupID: string, AssetTypeID: string) => void;
  handleEditAltNameClick: (AssetType: AssetTypes) => void;
  isEditable?: () => boolean;
}

const getSuffixes = (Suffixes) => {
  const suffixes = Suffixes.map((suffix) => suffix.SuffixName || "N/A");

  const filteredSuffixes = suffixes.filter((suffix) => suffix !== "N/A");

  return filteredSuffixes.length > 0
    ? filteredSuffixes.sort().join(", ")
    : suffixes.sort().join(", ");
};

const UnitsTable: React.FC<UnitsTableProps> = ({
  rows,
  onDelete,
  handleEditClick,
  handleEditAltNameClick,
  isEditable,
}) => {
  const [editUnits, setEditUnits] = React.useState<any>();
  const [editMode, setEditMode] = React.useState<boolean>(false);
  const [editAssetGroup, setEditAssetGroup] = React.useState<string>();
  const [editAssetType, setEditAssetType] = React.useState<string>();

  React.useEffect(() => {
    console.log("ROWWW:", rows);
  }, []);

  React.useEffect(() => {
    console.log("NEW ALT UNIT:", editUnits);
  }, [editUnits]);

  if (rows.length === 0) return null;
  console.log("ROWWW2:", rows);
  const renderActions = (AssetGroupID, AssetTypeID) => {
    return (
      <Fragment>
        {isEditable && isEditable() && (
          <Fragment>
            <IconButton>
              <EditSharpIcon
                onClick={() => handleEditClick(AssetGroupID, AssetTypeID)}
              />
            </IconButton>
            <IconButton onClick={() => onDelete(AssetGroupID, AssetTypeID)}>
              <DeleteSharpIcon />
            </IconButton>
          </Fragment>
        )}
      </Fragment>
    );
  };

  rows.sort((a, b) => {
    // handle possible undefined values
    if (!a.AssetGroupType && !b.AssetGroupType) return 0;
    if (!a.AssetGroupType) return -1;
    if (!b.AssetGroupType) return 1;
    if (!a.AssetTypes && !b.AssetTypes) return 0;
    if (!a.AssetTypes) return -1;
    if (!b.AssetTypes) return 1;
    if (a.AssetGroupType < b.AssetGroupType) return -1;
    if (a.AssetGroupType > b.AssetGroupType) return 1;
    if (a.AssetGroupType === b.AssetGroupType) {
      //@ts-ignore
      if (a.AssetTypes[0].AssetName < b.AssetTypes[0].AssetName) return -1;
      //@ts-ignore
      if (a.AssetTypes[0].AssetName > b.AssetTypes[0].AssetName) return 1;
    }
    console.log("SORTED");
    return 0;
  });

  const handleEditNameClick = (AssetGroupID, AssetTypeID) => {
    console.log("EDIT ", AssetGroupID, AssetTypeID);
    setEditAssetGroup(AssetGroupID);
    setEditAssetType(AssetTypeID);
    setEditMode(true);
    // setEditUnits(altUnitTextRef.current ? altUnitTextRef.current.value : "");
  };

  const handleEditNameSave = (AssetType: AssetTypes, AssetGroupID: string) => {
    console.log("EDIT SAVE ", editUnits);
    delete AssetType.Suffixes;
    delete AssetType.AssetName;
    handleEditAltNameClick({
      ...AssetType,
      AlternateUnit: editUnits,
      AssetGroupID,
    });
    setEditAssetGroup("");
    setEditAssetType("");
    setEditMode(false);
  };

  const handleEditNameCancel = (AssetGroupID, AssetTypeID) => {
    console.log("EDIT Cancel ", AssetGroupID, AssetTypeID, rows);
    setEditAssetGroup("");
    setEditAssetType("");
    setEditMode(false);
    setEditUnits(undefined);
  };

  return (
    <Grid container display='flex' flexDirection='row' justifyContent='center'>
      <TableContainer
        style={{ maxWidth: "80vw" }}
        component={Paper}
        sx={{ mx: 1, px: 1 }}
      >
        <Table size='small' aria-label='spanning table'>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontSize: "large" }}>Category</TableCell>
              <TableCell sx={{ fontSize: "large" }} align='left'>
                Unit Type
              </TableCell>
              <TableCell sx={{ fontSize: "large" }} align='left'>
                Alternate Unit Name
              </TableCell>
              <TableCell sx={{ fontSize: "large" }} align='right'>
                Action
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map(({ AssetGroupType, AssetGroupID, AssetTypes }) => (
              <Fragment>
                {AssetTypes && AssetTypes.length > 0 && (
                  <TableRow key={AssetGroupID}>
                    <TableCell rowSpan={AssetTypes.length + 1}>
                      {AssetGroupType}
                    </TableCell>
                  </TableRow>
                )}
                {AssetTypes &&
                  AssetTypes.map((assetType) => (
                    <Fragment>
                      <TableRow
                        style={{
                          backgroundColor: assetType.isDeleted
                            ? "whitesmoke"
                            : "",
                        }}
                        key={assetType.AssetTypeID}
                      >
                        <TableCell align='left'>
                          {assetType.AssetName}
                        </TableCell>
                        {editMode &&
                        editAssetGroup === AssetGroupID &&
                        editAssetType === assetType.AssetTypeID ? (
                          <TableCell align='left'>
                            <TextField
                              value={editUnits || assetType.AlternateUnit}
                              id={`${AssetGroupID}-${assetType.AssetTypeID}`}
                              label='AlternateUnitName'
                              defaultValue={assetType.AlternateUnit}
                              onChange={(newValue) =>
                                setEditUnits(newValue.target.value)
                              }
                            />

                            <IconButton>
                              <DoneIcon
                                onClick={() =>
                                  handleEditNameSave(
                                    assetType,
                                    AssetGroupID ? AssetGroupID : ""
                                  )
                                }
                              />
                            </IconButton>
                            <IconButton>
                              <CloseIcon
                                onClick={() =>
                                  handleEditNameCancel(
                                    AssetGroupID,
                                    assetType.AssetTypeID
                                  )
                                }
                              />
                            </IconButton>
                          </TableCell>
                        ) : (
                          <TableCell align='left'>
                            {assetType.AlternateUnit}
                            {assetType.AlternateUnit ? (
                              <IconButton>
                                <EditSharpIcon
                                  onClick={() =>
                                    handleEditNameClick(
                                      AssetGroupID,
                                      assetType.AssetTypeID
                                    )
                                  }
                                />
                              </IconButton>
                            ) : (
                              <IconButton>
                                <AddIcon
                                  onClick={() =>
                                    handleEditNameClick(
                                      AssetGroupID,
                                      assetType.AssetTypeID
                                    )
                                  }
                                />
                              </IconButton>
                            )}
                          </TableCell>
                        )}

                        <TableCell align='right'>
                          {renderActions(AssetGroupID, assetType.AssetTypeID)}
                        </TableCell>
                      </TableRow>
                    </Fragment>
                  ))}
              </Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>
  );
};

export default UnitsTable;
